import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=097404df&scoped=true"
import script from "./notification.ts?vue&type=script&lang=ts&external"
export * from "./notification.ts?vue&type=script&lang=ts&external"
import style0 from "./notification.vue?vue&type=style&index=0&id=097404df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@5.2.7_webpack@4.47.0___e99d8e97de94c5042a76fec31f8d8632/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097404df",
  null
  
)

export default component.exports